<template>
  <div class="wrapper">
    <section class="page-section covid-section">
      <Skmasjedid></Skmasjedid>
    </section>
  </div>
</template>

<script>
import Layout from "../views/layouts/Index.vue";
import Skmasjedid from "../components/sk/Skmasjedid.vue";
import Skziswaf from "../components/sk/Skziswaf.vue";
import { mapActions } from "vuex";

export default {
  components: {
    Layout,
    Skmasjedid,
    Skziswaf,
  },
  methods: {
    ...mapActions("transactions", ["resetForm"]),
  },
  mounted() {
    this.resetForm();
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  padding: 0px;
  min-height: calc(100vh - 0px);

  .accordion-button {
    font-size: 13px;
  }

  .accordion-button,
  .accordion-button.collapsed,
  .accordion-button.collapsed:focus,
  .accordion-button:focus {
    border-radius: 3px !important;
  }

  h5 {
    display: inline-block;
    font-size: 15px;
    margin: 0px;
    left: -15px;
    background: transparent linear-gradient(180deg, #28a745 0%, #145423 100%) 0%
      0% no-repeat padding-box;
    padding: 5px 40px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-bottom: 10px;
    margin-top: 30px;
  }

  .wrapper-in {
    padding: 10px;
    p {
      text-align: justify;
    }
  }
}

/* example */
.ps {
  height: 460px;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.footer {
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100% !important;

  img {
    width: 100% !important;
  }
}
</style>
